import React from "react";
import "../css/about.css";
import logo from "../assets/lna.jpg";
import nurseImage from "../assets/10.jpg";
import teamImage from "../assets/20.jpg";
import outreachImage from "../assets/44.jpg";
import certificatePDF from "../assets/doc/plan.pdf";

import presidentImage from "../assets/p.jpeg";
import deputyPresidentImage from "../assets/dp.jpg";
import secretaryGeneralImage from "../assets/sg.jpeg";
import deputySecretaryImage from "../assets/dsg.jpeg";
import treasurerImage from "../assets/t.jpeg";

const AboutUs = () => {
  const branches = [
    "Mabatho", "Roma Valley", "Makhoarane", "Makaota", "Motlejoeng", "Liphamola",
    "Melele", "Tebellong", "Lilala", "Seboche", "Masupha", "Maluti", "Linare",
    "Mamohau", "Likila", "Liphakoe", "Mants'onyane",
  ];
  const chapters = [
    "Student Nurses Chapter",
    "Lesotho Retired Nurses and Midwivies Chapter",
  ];

  return (
    <div className="about-container">
      <section className="hero-section">
        <img src={nurseImage} alt="Nurses in action" className="hero-image" />
        <div className="hero-text">
          <h1 className="gradient-title">Lesotho Nursing and Midwifery Organization (LENMO)</h1>
          <p className="sub-text">Empowering nurses and midwives to serve Lesotho with excellence</p>
        </div>
      </section>

      <section className="info-section card-style">
        <h2>Who Are We</h2>
        <p>
          Founded in 1963, the Lesotho Nurses Association (LNA) was officially registered on June 3, 1999. In February 2025, it transitioned into the Lesotho Nursing and Midwifery Organization (LENMO). LENMO is a registered trade union and professional association dedicated to supporting nurses and midwives through advocacy, collective bargaining, continuing education, and community outreach.
        </p>
        <h3>Mandate</h3>
        <ul className="styled-list">
          <li><strong>Advocacy for Nurses:</strong> Representing and protecting nurses' rights at all levels.</li>
          <li><strong>Representation:</strong> Providing a platform for local and international collaboration.</li>
          <li><strong>Collective Bargaining:</strong> Ensuring fair working conditions and benefits.</li>
        </ul>
      </section>

      <section className="three-columns">
        <div className="column-card shadow">
          <h3>Our Mission</h3>
          <p>
            To look after members' interests through professional development,
            rights protection, continuous education, and nursing standards.
          </p>
        </div>
        <div className="column-card shadow">
          <h3>Our Vision</h3>
          <p>
            Strong nursing leadership for a healthy, motivated, and efficient
            health workforce serving the people of Lesotho.
          </p>
        </div>
        <div className="column-card shadow">
          <h3>Our Motto</h3>
          <p>
            “We Care for the Carers” — committing nurses to the service of the
            Basotho Nation.
          </p>
        </div>
      </section>

      <section className="info-section fade-in">
        <h2>Our Logo</h2>
        <img src={logo} alt="LENMO Logo" className="responsive-img logo-border" />
        <p>
          The map of Lesotho bears the Nightingale lamp, surrounded by the
          organization name and motto.
        </p>
        <ul className="styled-list">
          <li><strong>Map:</strong> Green to symbolize patriotism and prosperity.</li>
          <li><strong>Lamp:</strong> Represents evidence-based modern nursing, bringing light to the ailing Basotho.</li>
          <li><strong>Text:</strong> "Lesotho Nursing and Midwifery Organization" above, and "We Care for the Carers”" below.</li>
        </ul>
      </section>

      <section className="info-section card-style">
        <h2>Our Objectives</h2>
        <ul className="styled-list">
          <li>Ensure service excellence in nursing.</li>
          <li>Raise status and integrity of the profession.</li>
          <li>Offer continuing education.</li>
          <li>Encourage research and collaboration.</li>
          <li>Describe and improve workforce conditions and satisfaction.</li>
        </ul>
      </section>

      <section className="info-section alt-bg zoom-in">
        <h2>Our Branches & Chapters</h2>
        <p>
          LENMO consists of 18 branches and 2 special chapters aligned with public and CHAL hospital structures.
        </p>
        <ul className="grid-list">
          {branches.map((b) => (<li key={b}>{b}</li>))}
        </ul>
        <h3>Chapters</h3>
        <ul className="grid-list">
          {chapters.map((c) => (<li key={c}>{c}</li>))}
        </ul>
      </section>

      <section className="info-section">
        <h2>Leadership</h2>
        <div className="leadership-members">
          {[{
            img: presidentImage,
            title: "President",
            name: "Mr Busi Qhala",
            desc: "Leads executive decisions and represents the organization."
          }, {
            img: logo,
            title: "Deputy President",
            name: "",
            desc: "Assists the president, chairs meetings in absence, and manages grievances."
          }, {
            img: secretaryGeneralImage,
            title: "Secretary General",
            name: "Mr Morephe Santi",
            desc: "Oversees administration and governance policy."
          }, {
            img: deputySecretaryImage,
            title: "Deputy Secretary General",
            name: "Mrs 'Maloronts'o Mokake",
            desc: "Supports secretary and manages publications."
          }, {
            img: treasurerImage,
            title: "Treasurer",
            name: "Ms Nthatisi Tlali",
            desc: "Manages finances, fundraising, and reporting."
          }].map((member, idx) => (
            <div className="leadership-member card-style" key={idx}>
              <img src={member.img} alt={member.title} className="leadership-img" />
              <p><strong>{member.title}:</strong> {member.name} — {member.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="info-section alt-bg fade-in">
        <h2>Community Outreach</h2>
        <img src={outreachImage} alt="Community Outreach" className="responsive-img" />
        <p>
          LENMO conducts outreach campaigns, workshops, and educational events
          across Lesotho to promote healthcare awareness and nursing leadership.
        </p>
      </section>

      <section className="info-section card-style">
        <h2>Resources</h2>
        <p>
          We provide professional certificates, member handbooks, and development
          material to our nurses and midwives.
        </p>
        <a href={certificatePDF} download className="btn-link">
          📄 Download Sample Certificate
        </a>
      </section>

      <section className="cta-section">
        <h2>Become a Member</h2>
        <p>
          Join LENMO today and be part of the national movement to empower and
          professionalize nursing and midwifery in Lesotho.
        </p>
        <a href="/membership" className="btn-primary">Register Now</a>
      </section>

      <footer className="footer">
        <img src={logo} alt="LENMO Logo" className="footer-logo" />
        <p>© {new Date().getFullYear()} Lesotho Nursing and Midwifery Organization</p>
        <p>
          Contact: <a href="mailto:info@lenmo.org.ls">info@lenmo.org.ls</a> | 
          Follow us on <a href="https://web.facebook.com/LesothoNursingAssociation" target="_blank" rel="noreferrer">Facebook</a>
        </p>
      </footer>
    </div>
  );
};

export default AboutUs;
